import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const LongBackArrowIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={18}
      height={14}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M7.707 2.374A1 1 0 006.293.959L.96 6.293a.997.997 0 000 1.414l5.333 5.333a1 1 0 001.414-1.414L4.081 8H17a1 1 0 100-2H4.08l3.627-3.626z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default LongBackArrowIcon;
